import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rd-items-start rd-flex rd-flex-col rd-justify-center rd-w-full test-mode-banner-content" }
const _hoisted_2 = { class: "rd-items-center rd-flex rd-flex-row rd-justify-between rd-mb-4 rd-w-full sm-max:rd-flex-col sm-max:rd-items-start" }
const _hoisted_3 = { class: "rd-items-center rd-flex rd-text-xs" }
const _hoisted_4 = ["href"]

import { useRenderStore } from '@/builder/stores/renderStore';
import { MerchantType, PaymentMethodType } from '@/enums';
import TestPaymentsCard from "./TestPaymentsCard.vue"
import TestPaymentsAch from "./TestPaymentsAch.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'TestPayments',
  setup(__props) {

const renderStore = useRenderStore();

const morePaymentMethodsUrl = renderStore.page.merchantType === MerchantType.StripeUnified
    ? "https://docs.stripe.com/testing#cards"
    : "https://developer.authorize.net/hello_world/testing_guide.html"


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["test-mode-banner-container test-payment-types", { '!rd-mb-5': _unref(renderStore).page.merchantType === _unref(MerchantType).AuthorizeNet }])
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "test-mode-banner-top w-full" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "rd-flex rd-text-xs rd-font-semibold rd-leading-none rd-uppercase sm-max:rd-mb-2" }, " Test Payment Types ", -1)),
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("a", {
            class: "more-methods rd-font-medium",
            href: _unref(morePaymentMethodsUrl),
            target: "_blank"
          }, " More Test Payment Methods ", 8, _hoisted_4),
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa-solid fa-arrow-right rd-ml-1" }, null, -1))
        ])
      ]),
      (_unref(renderStore).gift.paymentMethodType == _unref(PaymentMethodType).Credit || _unref(renderStore).page.merchantType === _unref(MerchantType).StripeUnified)
        ? (_openBlock(), _createBlock(TestPaymentsCard, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(renderStore).gift.paymentMethodType == _unref(PaymentMethodType).ACH && _unref(renderStore).page.merchantType === _unref(MerchantType).AuthorizeNet)
        ? (_openBlock(), _createBlock(TestPaymentsAch, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})